import { render, staticRenderFns } from "./PaddingLeftRightIcon.vue?vue&type=template&id=23fb9bd8&"
import script from "./PaddingLeftRightIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingLeftRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports